export default __webpack_public_path__ + "static/media/gmx-logo-with-name.28ece5d4.svg";